import { useCallback, useEffect, useState } from "react";
import MenuTop from "../../../../components/menu/top/menu-top";
import planData from "../../../../features/plans/forms/plans-data";
import './style.css';
import { createPlanService,  fetchPlanTypes } from "../../../../features/plans/service/plan-service";
import { FormProps } from "../../../../shared/interfaces/form";
import Form from "../../../../components/form/form";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { useNavigate } from 'react-router-dom';
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import InfoComponent from "../../../../components/info/info";

export function AddPlan() {
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<FormProps[] | undefined>();

    const handleCreatePlan = async (formData: any) => {
        if(formData.price) { formData.price = Math.round(Number(formData.price) * 100); }

        if(formData?.isUnlimited) { formData.quantityProjects = null; }

        formData.payed = false;

        if(formData) {
            const response = await createPlanService(formData);

            if(response) {
                showAlert('Plano criado com sucesso', SEVERITY.SUCCESS);
                navigate('/planos');
            }
        }
    };

    const fetchPlanTypesData = useCallback(async () => {
        try {
            const planTypes = await fetchPlanTypes();
            const planTypesOptions = planTypes?.map(({ name, id}: any) => ({ label: name, value: id }));

            setFormData(planData(undefined, undefined, planTypesOptions));
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        fetchPlanTypesData();
    }, [fetchPlanTypesData]);

    return (
        <div className="container-client">
            <MenuTop />
            <div className='container-client__content'>
                <Breadcrumb links={['Planos', 'Adicionar plano']} href={['/planos', '']} onNavigate={navigate}/>
                {formData && (
                    <>
                        <InfoComponent />
                        <Form
                            data={formData}
                            onSubmitForm={handleCreatePlan}
                            title="Adicionar plano"
                            onCancel={() => navigate('/planos', {replace: true})}
                        />
                    </>
                )}
            </div>
        </div>
    );
}